import { useState } from 'preact/hooks';
import { ApiError } from '../lib/api.js';
import { useAuth } from '../lib/auth.js';

export function Login() {
  const { login, forbidden } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: Event) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email, password);
    } catch (err) {
      setError(
        err instanceof ApiError ? err.message : 'Login failed — check the API is reachable.',
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <div class="login-shell">
      <div class="login-card">
        <h1 class="login-logo">STILLSUN</h1>
        <p class="login-sub">Admin dashboard</p>
        {forbidden && (
          <div class="error-banner">This account doesn&rsquo;t have admin or owner access.</div>
        )}
        {error && <div class="error-banner">{error}</div>}
        <form onSubmit={onSubmit}>
          <div class="field">
            <label for="email">Email</label>
            <input
              id="email"
              class="input"
              type="email"
              autocomplete="username"
              required
              value={email}
              onInput={(e) => setEmail((e.target as HTMLInputElement).value)}
            />
          </div>
          <div class="field">
            <label for="password">Password</label>
            <input
              id="password"
              class="input"
              type="password"
              autocomplete="current-password"
              required
              value={password}
              onInput={(e) => setPassword((e.target as HTMLInputElement).value)}
            />
          </div>
          <button
            type="submit"
            class="btn btn-primary"
            style={{ width: '100%', marginTop: '6px' }}
            disabled={busy}
          >
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
